import React from "react";
import NotFound from "../images/NotFound";

const NotFound404ValidUser = () => {
  return (
    <div className="employees">
      <div className="employees-wrap items-center justify-center !bg-[#fafafa]">
        <h1 className="text-3xl text-zinc-600">The page you're looking for doesn't exist</h1>
        <div className="-mt-10">
          <NotFound />
        </div>
      </div>
    </div>
  );
};

export default NotFound404ValidUser;
